import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46a5073c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trust-data-external-examiner-sign-up-approval" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ATCS External Examiner Sign-up approval", -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "search-inputs" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_9 = { class: "checkbox-button ml-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Submitted")
], -1))
const _hoisted_11 = { class: "checkbox-button ml-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Rejected")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "space-filler",
  style: {"flex-grow":"1"}
}, null, -1))
const _hoisted_14 = { class: "ee-signup-table" }
const _hoisted_15 = { class: "ls-table" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["colspan"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = { "data-label": "LawID" }
const _hoisted_23 = { "data-label": "Name" }
const _hoisted_24 = { "data-label": "Firm Name" }
const _hoisted_25 = { "data-label": "Suburb" }
const _hoisted_26 = {
  "data-label": "Status",
  class: "status"
}
const _hoisted_27 = { "data-label": "Actions" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_ApproveRejectToBeEEModal = _resolveComponent("ApproveRejectToBeEEModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event)),
              placeholder: "Enter name/ LawID"
            }, null, 512), [
              [_vModelText, _ctx.searchKeyword]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showSubmmitted) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showSubmmitted]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showRejected) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showRejected]
            ]),
            _hoisted_12
          ]),
          _hoisted_13
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("table", _hoisted_15, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("div", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_17)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_19)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredEESignUpForms.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    _createElementVNode("td", {
                      colspan: _ctx.filteredEESignUpForms.length
                    }, "No Records", 8, _hoisted_21)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredEESignUpForms.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.filteredEESignUpForms, (a) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_22, _toDisplayString(a?.lawId ?? ''), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(a?.firstName ?? '') + " " + _toDisplayString(a?.surname ?? ''), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(a?.firmName ?? ''), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(a?.suburb ?? ''), 1),
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("span", {
                            class: _normalizeClass(a?.eeSignUpFormStatus?.name=='Submitted' ? 'warning' : 'error')
                          }, _toDisplayString(a?.eeSignUpFormStatus?.name ?? ''), 3)
                        ]),
                        _createElementVNode("td", _hoisted_27, [
                          (a?.eeSignUpFormStatus?.name == 'Submitted')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  class: "btn btn-default sml mr-2",
                                  onClick: $event => (_ctx.approveToBeEE(a))
                                }, "Approve", 8, _hoisted_28),
                                _createElementVNode("button", {
                                  class: "btn btn-default sml",
                                  onClick: $event => (_ctx.rejectToBeEE(a))
                                }, "Reject", 8, _hoisted_29)
                              ], 64))
                            : (a?.eeSignUpFormStatus?.name == 'Rejected' || a?.eeSignUpFormStatus?.name == 'Approved')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn btn-default sml",
                                  onClick: $event => (_ctx.viewSignUpForm(a))
                                }, "View", 8, _hoisted_30))
                              : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showApproveRejectModal)
      ? (_openBlock(), _createBlock(_component_ApproveRejectToBeEEModal, {
          key: 0,
          actionType: _ctx.actionType,
          eeSignUpForm: _ctx.selectedEESignUpForm,
          onClose: _cache[3] || (_cache[3] = $event => (_ctx.onApproveRejectModalClosed()))
        }, null, 8, ["actionType", "eeSignUpForm"]))
      : _createCommentVNode("", true)
  ]))
}